var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.flags.length)?_c('div',{staticClass:"flags text--white"},[_c('svg',[_c('use',{attrs:{"xlink:href":"#alert"}})]),_vm._v(" "),_c('div',_vm._l((_vm.flags),function(flag,index){return _c('p',{key:index,staticClass:"small semi"},[_vm._v(_vm._s(flag))])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }